// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"79778": "00cb2b66","80290": "d4440e1a","96999": "8a87e2ee",}[chunkId] + ".css"
}